import React from'react';
import SubmitButton             from '../Fields/SubmitButton';


function Popup(props){ 
let FaCross = require('react-icons/lib/fa/close');
let globalConfig = require('Config');
let phoneNo = globalConfig.landlord.phone_no;

return(props.trigger)?( 
   
    <modal-container class='modal-active' >
        {props.children} 
                        <modal>
                            <div className="modal-header">
                                Please read the following information
                            
                                <a className="close-cross" >
                                <FaCross  onClick={closePopup}/>
                                </a>
                            </div>
                            <div className="modal-body">
                                <div>
                                    <p> 
                                        <b>Fair Presentation of Risk</b><br/><br/> 
                                        You must make a fair presentation of the risk to us. This means that you must tell us about any 'material circumstances' relevant to your insurance cover that you know or should have known following a reasonable search. <br/> This applies when you are applying for the cover, during renewal and to any changes whilst your policy is in place. A 'material circumstance' is something that could influence the decision the insurer makes about whether to offer you a policy and what terms and conditions to apply.<br/> <br/> 

                                        Simply put, you are responsible for the accuracy and completeness of the information you provide to us. If you are in any doubt as to whether something is a material circumstance it is best to tell us about it.<b>You can do this easily by calling us {phoneNo} on  and one of our expert Landlords teams will be happily help</b><br/><br/> 
                                        If you do not do this and fail to tell us about a material circumstance, your policy may not be valid or the policy may not cover you fully or at all. <br/><br/> 
                                        If the sums insured that you have selected are not adequate this may result in the amount that we pay you in the event of a claim being reduced.<br/><br/> 
                                        <b>Who this policy is intended for:</b><br/><br/> 
                                        This is a commercial insurance policy for landlords who own and let their property for rental income.<br/><br/> 
                                        If this does not describe your situation, please contact us. HomeLet is a trading name of Barbon Insurance Group Limited who are owned by PIB Group. As part of a larger Group  that offer a wider range of types of insurance policies, we have access to experienced insurance brokers who are able to discuss solutions to meet your insurance needs and requirements. 
                                        <br/> <br/> 
                                    </p>
                                    <hr style= {{width:'100%'}}/>
                                </div>
                               
                                <div style= {{float:'right', width:'200px'}}>
                                <SubmitButton style= {{float:'inherit'}}
                                label= 'AGREE AND CONTINUE'
                                onClick={closePopup}
                                />
                            </div>
                            </div>
                            
                        </modal>
        </modal-container>

):""; 

} 
function closePopup()
{
    $(".modal-active").css("display", "none"); 
}

export default Popup 

 







/** WEBPACK FOOTER **
 ** ./src/components/Modals/Popup.js
 **/